import { useParams } from 'react-router-dom';
import useSubmissions from './hooks/useSubmissions';
import SubmissionsView from './view';
import SubmissionDetails from './details';

export default function FormsSubmissions() {
    const { itemId } = useParams();

    if (itemId) {
        return <SubmissionDetails submissionId={itemId} />;
    }

    return <SubmissionsListController />;
}

function SubmissionsListController() {
    const state = useSubmissions();
    return <SubmissionsView {...state} />;
}
